var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleoffcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H18C23.525 6 28 10.475 28 16C28 21.525 23.525 26 18 26H13C7.475 26 3 21.525 3 16C3 10.475 7.475 6 13 6Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21C14.3261 21 15.5979 20.4732 16.5355 19.5355C17.4732 18.5979 18 17.3261 18 16C18 14.6739 17.4732 13.4021 16.5355 12.4645C15.5979 11.5268 14.3261 11 13 11C11.6739 11 10.4021 11.5268 9.46447 12.4645C8.52678 13.4021 8 14.6739 8 16C8 17.3261 8.52678 18.5979 9.46447 19.5355C10.4021 20.4732 11.6739 21 13 21Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleoffcircle);
export default __webpack_public_path__ + "static/media/toggleoffcircle.b05f44aaa96c6efe33961cf3e43bfcc6.svg";
export { ForwardRef as ReactComponent };